// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1w9sJ","insightsList":"newBusinessInsightsMenu_insightsList__30mXv","active":"newBusinessInsightsMenu_active__2LwFe"};